module.exports = __webpack_public_path__ + "img/prdays_njem_logo.349ed0aa.png";